import { FC, useCallback } from 'react';

import { ExpirationDate, StyledTextField } from 'components';
import { Chassis } from 'types';
import { useNewTransaction } from '..';

const ChassisDetails: FC = () => {
  const { bulk, chassis, transaction, setChassis } = useNewTransaction();

  const setLpExpDate = useCallback(
    (licensePlateExpirationDate?: number) => setChassis(c => new Chassis({ ...c, licensePlateExpirationDate })),
    [setChassis]
  );

  const setFmcsaDate = useCallback(
    (fmcsaDate?: number) => setChassis(c => new Chassis({ ...c, fmcsaDate })),
    [setChassis]
  );

  return !!bulk || !chassis.unitNumber ? null : (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>CHASSIS DETAILS</h4>
      </div>
      <div className="card-body grid-3">
        <StyledTextField
          fullWidth
          label="LICENSE PLATE"
          value={chassis.licensePlate ?? ''}
          onChange={e => setChassis(c => new Chassis({ ...c, licensePlate: e.target.value.toUpperCase() }))}
          disabled={!transaction.inbound}
          data-cy="chassis-license-plate-input"
        />
        <ExpirationDate
          label="LP EXPIRATION"
          date={chassis.licensePlateExpirationDate}
          setDate={setLpExpDate}
          disabled={!transaction.inbound}
          data-cy="chassis-license-plate-expiration-date-input"
        />
        <ExpirationDate
          label="FMCSA DATE"
          date={chassis.fmcsaDate}
          setDate={setFmcsaDate}
          disabled={!transaction.inbound}
          data-cy="chassis-fmcsa-date-input"
        />
      </div>
    </div>
  );
};

export default ChassisDetails;
